/**
 * Дата в формате YYYY-MM-DD по локальному календарю (для v-date-picker и query API).
 */
export function formatDateAsYmdLocal(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Диапазон по умолчанию: с 1-го числа предыдущего месяца по текущее число (локально).
 */
export function defaultDateRangePreviousMonthToToday(): [string, string] {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  return [formatDateAsYmdLocal(start), formatDateAsYmdLocal(today)];
}
